function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { COMMON, LAYOUT, TYPOGRAPHY } from '../constants';
const BaseHeading = styled.h1.withConfig({
  displayName: "Heading__BaseHeading",
  componentId: "sc-14noc5p-0"
})(["", " ", " ", ""], COMMON, LAYOUT, TYPOGRAPHY);
const defaultTextSizes = {
  h1: 7,
  h2: 6,
  h3: 5
};

const Heading = ({
  as,
  textSize,
  children,
  ...props
}) => {
  const defaultTextSize = defaultTextSizes[as] || defaultTextSizes.h1;
  let textSizeVal;

  if (!textSize) {
    textSizeVal = defaultTextSize;
  } else {
    textSizeVal = textSize;
  }

  return React.createElement(BaseHeading, _extends({
    as: as,
    textSize: textSizeVal
  }, props), children);
};

BaseHeading.defaultProps = {
  caps: false,
  color: 'text.black',
  ellipsis: false
};
BaseHeading.propTypes = { ...COMMON.propTypes,
  ...LAYOUT.propTypes,
  ...TYPOGRAPHY.propTypes,

  /** Set text transform uppercase */
  caps: PropTypes.bool,

  /** Set text to ellipsis on overflow */
  ellipsis: PropTypes.bool
};
Heading.defaultProps = BaseHeading.defaultProps;
Heading.propTypes = BaseHeading.propTypes;
BaseHeading.displayName = 'BaseHeading';
Heading.displayName = 'Heading';
export default Heading;